<template>
  <a-layout  :style="{width:'100vw',height:'100vh'}">
      <a-layout-sider  :style="{ background:'white !important',}">
          <Sider/>
      </a-layout-sider>
      <a-layout>
        <a-layout-header class="a-heder" :style="{ background:'white !important'}">
            <Header/>
        </a-layout-header>
          <a-layout-content>
              <router-view :key="$route.path"></router-view>
          </a-layout-content>
      </a-layout>
  </a-layout>
</template>

<script>
import Sider from '../components/sider'
import Header from '../components/header'
export default {
      components:{
        Sider,
        Header
      },

}
</script>

<style lang="less">
@media screen and (max-width:900px) {
  .ant-layout-sider {
    display: none;
  }

}

</style>